import React, { useEffect, useRef, useState } from 'react';
import crimeIcon from './images/crime-icon.png';

const MapComponent = ({ crimeData, interactive = false, setLatitude, setLongitude, latitude, longitude }) => {
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);

  useEffect(() => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const initMap = () => {
      const newMap = new window.google.maps.Map(mapRef.current, {
        center: { lat: latitude || 41.8781, lng: longitude || -87.6298 },
        zoom: 12,
        gestureHandling: 'greedy',
      });

      const newMarker = new window.google.maps.Marker({
        position: { lat: latitude || 41.8781, lng: longitude || -87.6298 },
        map: newMap,
        draggable: interactive,
        title: interactive ? 'Drag me!' : 'Crime Location',
      });

      setMap(newMap);
      setMarker(newMarker);
    };

    if (!map) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
      script.async = true;
      document.head.appendChild(script);
      window.initMap = initMap;
      return () => {
        document.head.removeChild(script);
        window.initMap = undefined;
      };
    } else {
      marker.setPosition({ lat: latitude || 41.8781, lng: longitude || -87.6298 });
      map.setCenter({ lat: latitude || 41.8781, lng: longitude || -87.6298 });
    }
  }, [latitude, longitude]);

  useEffect(() => {
    if (interactive && map && marker) {
      marker.addListener('dragend', (event) => {
        const newPos = { lat: event.latLng.lat(), lng: event.latLng.lng() };
        setLatitude(newPos.lat);
        setLongitude(newPos.lng);
      });

      map.addListener('click', (e) => {
        const newPos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        marker.setPosition(newPos);
        setLatitude(newPos.lat);
        setLongitude(newPos.lng);
      });
    }
  }, [interactive, map, marker, setLatitude, setLongitude]);

  useEffect(() => {
    if (map) {
      const infoWindow = new window.google.maps.InfoWindow();

      crimeData.forEach((crime) => {
        const icon = {
          url: crimeIcon,
          scaledSize: new window.google.maps.Size(32, 32),
        };

        crime.locations.forEach((location) => {
          const marker = new window.google.maps.Marker({
            position: { lat: location.Latitude, lng: location.Longitude },
            map,
            icon: icon,
          });

          marker.addListener('click', () => {
            infoWindow.setContent(`<div><strong>${crime.primary_type}</strong></div>`);
            infoWindow.open(map, marker);
          });
        });
      });
    }
  }, [crimeData, map]);

  return <div ref={mapRef} className="w-full h-96"></div>;
};

export default MapComponent;